<template>
  <div class="page-content">
    <div class="container-fluid p-4">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * The page surface every forwards v2 route renders into.
 *
 * `.page-content` (assets/utilities.scss) is the same light surface `DashboardView` uses, and it
 * owns the page's scrolling, so it has to be the routed component's own root rather than something a
 * section opts into. It dates from when these pages sat in `UserFacingLayout`, whose dark green
 * `#dashboard-wrapper` put body text and white cards on a dark ground (FIX4-1 item 2); under
 * `/admin` it keeps them looking as they did.
 */
</script>
